import { useEffect, useState } from "react";

export default function ExportFeildCheckbox({item , arrayWhichSelected , handlePush , handleDelete}) {
    const [checked , setChecked] = useState();
    const handleChange = (e) => {
        if(e.target.checked) {
            handlePush(item.name);
        }else {
            handleDelete(item.name);
        }
    }
    useEffect(() => {
        const find = arrayWhichSelected?.find(name => name == item.name);
        find ? setChecked(true) : setChecked(false)
    } , [arrayWhichSelected])
    return (
        <div className="col-sm-12 col-md-3 flex items-center">
            <input 
            type="checkbox" 
            id={item.name} 
            value={item.name} 
            className=" scale-110 cursor-pointer translate-y-[-1px]"
            checked = {checked}
            onChange={e => handleChange(e)}
            />
            <label htmlFor={item.name} className="mx-1 cursor-pointer">{item.title}</label>
        </div>
    )
}